import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { WithChildren } from 'ts-types';

export const SkeletonWrapper: FC<{ isShow: boolean; height: number; width?: number | string } & WithChildren> = ({
  isShow,
  height,
  children,
  width
}) => {
  if (isShow) return <Skeleton height={height} width={width} />;
  return <>{children}</>;
};
